import { render } from "./WizardTabContent.vue?vue&type=template&id=36f8fdca"
import script from "./WizardTabContent.vue?vue&type=script&lang=js"
export * from "./WizardTabContent.vue?vue&type=script&lang=js"
script.render = render

export default script